export const ZIP_CODE_VALIDATION_ERROR_MSGS = {
  TYPE_ERROR: 'Please input only digits.',
  LENGTH_ERROR: 'Please input 5 digits.'
}
